const modThreeData = {
  module: 3,
  category: 'Frontend Frameworks',
  days: [
    {
      link: "https://replit.com/@kaylaewood/adventday1",
      emoji: "🎁"
    },
    {
      link: "https://gist.github.com/kaylagordon/f5fd3e3ce34f63d5ca61e8f6f6ee8fa0",
      emoji: "💰"
    },
    {
      link: "https://github.com/turingschool-examples/card-maker-cypress-tdd",
      emoji: "💌"
    },
    {
      link: "https://gist.github.com/kaylagordon/e4df98dba4b33b04c2822a205e676d35",
      emoji: "❄️"
    },
    {
      link: "https://github.com/turingschool-examples/responsive-css-imperfectfoods",
      emoji: "🍎"
    },
    {
      link: "https://gist.github.com/kaylagordon/7d22b19c73e2bddfa6260c94f81ce26d",
      emoji: "🍦"
    },
    {
      link: "https://turingschool.notion.site/Advent-Theme-Rest-Day-Notes-63c185f90901476b80ecc9c73045bb2b",
      emoji: "😌"
    },
    {
      link: "https://github.com/turingschool-examples/math4you-fe",
      emoji: "🧮"
    },
    {
      link: "https://gist.github.com/kaylagordon/a5477013405461e1820dfd4efcd09687",
      emoji: "🧸"
    },
    {
      link: "https://replit.com/@frontend-instructors/spicy-soup#index.js",
      emoji: "🍜"
    }
  ]

};



export default modThreeData;
